import React from "react";
import { QRCodeSVG } from "qrcode.react";

const QRWithIconDonor = ({ value, iconUrl }) => {
  const size = 90; // QR size
  const iconSize = 30; // Icon size

  return (
    <div
      style={{
        position: "relative",
        width: size,
        height: size,
        border:1,
        borderColor:'#c2c2c2ff',
        borderRadius:12,
        marginTop:10,
      }}
    >
      <QRCodeSVG
        value={value}
        size={size}
       
        level="H" // Use high error correction to allow image overlay
        includeMargin={true}
        style={{ width: "100%", height: "100%" }}
      />
      <img
        src={iconUrl}
        alt="icon"
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          width: iconSize,
          height: iconSize,
          transform: "translate(-50%, -50%)",
          borderRadius: "8px", // optional, for rounded icon
          background: "#fff", // white background to ensure visibility
          padding: "1px", // space around icon
        }}
      />
    </div>
  );
};

export default QRWithIconDonor;
